/* NVA Jewelers — theme scripts */
(function () {
  'use strict';
  var N = window.NVA || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var fmt = N.money || '${{amount}}';
    var v = (cents / 100);
    var withCommas = function (n, d) { return n.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withCommas(v, 0);
      if (k === 'amount_with_comma_separator') return withCommas(v, 2).replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
      if (k === 'amount_no_decimals_with_comma_separator') return withCommas(v, 0).replace(/,/g, '.');
      return withCommas(v, 2);
    });
  }

  /* ---------- emblem light sweep ---------- */
  function sweep(svg) {
    if (svg.classList.contains('emb-pic')) { svg.classList.remove('is-shine'); void svg.offsetWidth; svg.classList.add('is-shine'); return; }
    $$('.emb-sweep', svg).forEach(function (a) { try { a.beginElement(); } catch (e) {} });
  }
  function initEmblems(root) {
    if (N.motion === 'none' || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var svg = en.target;
        if (en.isIntersecting) {
          if (!svg._swept) { svg._swept = true; setTimeout(function () { sweep(svg); }, 250); }
          if (N.motion === 'loop' && !svg._loop) { svg._loop = setInterval(function () { sweep(svg); }, 6500); }
        } else if (svg._loop) { clearInterval(svg._loop); svg._loop = null; }
      });
    }, { threshold: .4 });
    $$('[data-emblem]', root).forEach(function (svg) { if (!svg.closest('#NvaIntro')) io.observe(svg); });
  }

  /* ---------- home emblem behaviour ---------- */
  function initHome() {
    var isHome = location.pathname === (N.routes && N.routes.root) || location.pathname === '/';
    $$('[data-home]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { var s = $('[data-emblem]', a); if (s && !reduce) sweep(s); });
      a.addEventListener('click', function (e) {
        if (isHome) {
          e.preventDefault();
          closeDrawers();
          window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
          var s = $('[data-emblem]', a); if (s) sweep(s);
          return;
        }
        if (N.replayIntro) { try { sessionStorage.setItem('nva-replay', '1'); } catch (err) {} }
      });
    });
  }

  /* ---------- header ---------- */
  function initHeader() {
    var hdr = $('[data-header]'); if (!hdr) return;
    var shrink = hdr.getAttribute('data-shrink') === 'true';
    var ticking = false;
    // Keep the header's full-size space reserved so shrinking never moves the page
    // (moving the page used to bounce the scroll position and make the header shake).
    var wrap = hdr.parentElement;
    var pin = wrap && hdr.classList.contains('hdr--sticky') && !hdr.classList.contains('hdr--clear');
    function measure() {
      if (!pin || hdr.classList.contains('is-shrunk')) return;
      var h = hdr.offsetHeight; if (h) wrap.style.height = h + 'px';
    }
    if (pin) {
      wrap.classList.add('hdr-pin');
      measure();
      window.addEventListener('resize', measure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(hdr);
      window.addEventListener('load', measure);
    }
    function onScroll() {
      var y = window.scrollY || window.pageYOffset || 0;
      hdr.classList.toggle('is-scrolled', y > 10);
      if (pin) hdr.classList.toggle('is-pinned', wrap.getBoundingClientRect().top <= 0);
      if (shrink) {
        // shrink past 160px, grow back only above 60px, so it can't flip-flop near one line
        if (!hdr.classList.contains('is-shrunk') && y > 160) hdr.classList.add('is-shrunk');
        else if (hdr.classList.contains('is-shrunk') && y < 60) { hdr.classList.remove('is-shrunk'); }
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();

    var pop = $('[data-search-pop]');
    $$('[data-open-search]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (!pop) return; e.preventDefault();
        pop.hidden = !pop.hidden; if (!pop.hidden) $('input[type=search]', pop).focus();
      });
    });
    $$('[data-close-search]').forEach(function (b) { b.addEventListener('click', function () { pop.hidden = true; }); });
  }

  /* ---------- announcement ---------- */
  function initAnnounce() {
    var a = $('[data-announce]'); if (!a) return;
    var msgs = $$('.announce__msg', a); if (msgs.length < 2) return;
    var i = 0, secs = parseFloat(getComputedStyle(a).getPropertyValue('--announce-speed')) || 5;
    setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, secs * 1000);
  }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(d) {
    if (!d) return; lastFocus = document.activeElement;
    d.hidden = false; requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var f = $('button, a, input', d.querySelector('.drawer__panel')); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      setTimeout(function () { d.hidden = true; }, 420);
    });
    document.documentElement.style.overflow = '';
    if (lastFocus) try { lastFocus.focus(); } catch (e) {}
  }
  function initDrawers() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-close-drawer]')) { closeDrawers(); return; }
      var m = e.target.closest('[data-open-menu]');
      if (m) { e.preventDefault(); openDrawer($('[data-menu-drawer]')); return; }
      var c = e.target.closest('[data-open-cart]');
      if (c && $('[data-cart-drawer]')) { e.preventDefault(); openDrawer($('[data-cart-drawer]')); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawers(); var z = $('[data-zoom-layer]'); if (z) z.hidden = true; var p = $('[data-search-pop]'); if (p) p.hidden = true; }
    });
  }

  /* ---------- cart ---------- */
  function refreshCart(open) {
    return fetch(N.routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var html = data['cart-drawer']; var old = $('[data-cart-drawer]');
      if (html && old) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = $('[data-cart-drawer]', tmp);
        if (fresh) {
          var wasOpen = old.classList.contains('is-open');
          old.innerHTML = fresh.innerHTML;
          initEmblems(old);
          if (open && !wasOpen) openDrawer(old);
        }
      }
      return fetch(N.routes.cart + '.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    });
  }
  function initCartDrawer() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-change]'); if (!b || !b.closest('[data-cart-drawer]')) return;
      e.preventDefault();
      fetch(N.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.getAttribute('data-line'), quantity: +b.getAttribute('data-qty-change') }) })
        .then(function () { return refreshCart(false); });
    });
  }

  /* ---------- product page ---------- */
  function initProduct(sec) {
    var jsonEl = $('[data-variant-json]', sec);
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var idInput = $('[data-variant-id]', sec);
    var addBtn = $('[data-add-btn]', sec);
    var buyRow = $('[data-buy-row]', sec);
    var dyn = $('[data-buy-dynamic]', sec);
    var priceWrap = $('[data-price-wrap] [data-price]', sec);
    var porMode = sec.getAttribute('data-por-mode');
    var porTag = sec.hasAttribute('data-por-tag');

    function showMedia(id) {
      $$('.pdp__slide', sec).forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-media-id') == id); });
      $$('.pdp__thumb', sec).forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-thumb') == id); });
    }
    $$('[data-thumb]', sec).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });

    // swipe on gallery
    var stage = $('.pdp__stage', sec), sx = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) < 40) return;
        var slides = $$('.pdp__slide', sec); var cur = slides.findIndex(function (s) { return s.classList.contains('is-on'); });
        var next = (cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
        showMedia(slides[next].getAttribute('data-media-id'));
      });
    }

    // zoom
    var zl = $('[data-zoom-layer]');
    $$('[data-zoom]', sec).forEach(function (b) {
      b.addEventListener('click', function () { if (!zl) return; $('img', zl).src = b.getAttribute('data-zoom'); zl.hidden = false; });
    });
    if (zl) zl.addEventListener('click', function () { zl.hidden = true; });

    // variants
    function selected() { return $$('[data-opt]:checked', sec).map(function (i) { return i.value; }); }
    function onVariant() {
      if (!variants) return;
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      opts.forEach(function (o, i) { var l = $('[data-opt-label="' + i + '"]', sec); if (l) l.textContent = o; });
      if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = N.strings.unavailable; } return; }
      idInput.value = v.id;
      var por = porMode === 'hide' || porTag || (porMode === 'zero' && v.price === 0);
      if (buyRow) buyRow.classList.toggle('is-hidden', por);
      if (dyn) dyn.classList.toggle('is-hidden', por);
      $$('[data-only-por]', sec).forEach(function (el) { el.classList.toggle('is-hidden', !por); });
      if (priceWrap && !por) {
        var html = '<span class="price__now">' + money(v.price) + '</span>';
        if (v.compare_at_price > v.price) html += '<s class="price__was">' + money(v.compare_at_price) + '</s>';
        priceWrap.className = 'price'; priceWrap.innerHTML = html;
      } else if (priceWrap && por) {
        priceWrap.className = 'price price--request';
        var t = document.querySelector('.price__request'); priceWrap.innerHTML = '<span class="price__request">' + (t ? t.textContent : 'Price on request') + '</span>';
      }
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? N.strings.add : N.strings.soldOut; }
      if (v.featured_media) showMedia(v.featured_media.id);
      var url = sec.getAttribute('data-url') + '?variant=' + v.id;
      history.replaceState({}, '', url);
    }
    $$('[data-opt]', sec).forEach(function (i) { i.addEventListener('change', onVariant); });

    // quantity
    $$('[data-qty-step]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('input[name=quantity]', sec); var n = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10)); inp.value = n;
      });
    });

    // add to cart
    var form = $('[data-product-form] form', sec);
    var err = $('[data-form-err]', sec);
    if (form && document.body.getAttribute('data-cart-type') === 'drawer') {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.classList.add('is-loading'); }
        if (err) err.hidden = true;
        fetch(N.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status && res.description) { if (err) { err.textContent = res.description; err.hidden = false; } return; }
            return refreshCart(true);
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); } });
      });
    }

    // share
    $$('[data-share]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-share-url'), title = b.getAttribute('data-share-title');
        if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { var ok = $('[data-share-ok]', sec); if (ok) { ok.hidden = false; setTimeout(function () { ok.hidden = true; }, 2200); } });
      });
    });
  }

  /* ---------- related products ---------- */
  function initRelated() {
    $$('[data-related]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = $('[data-related]', tmp);
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveal(el); initEmblems(el); }
        else { var wrap = el.closest('.shopify-section'); if (wrap) wrap.style.display = 'none'; }
      }).catch(function () {});
    });
  }

  /* ---------- collection filters ---------- */
  function initFilters() {
    var f = $('[data-filter-form]'); if (!f) return;
    var sort = $('[data-sort]', f);
    if (sort) sort.addEventListener('change', function () { f.submit(); });
    $$('.filter', f).forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) $$('.filter', f).forEach(function (o) { if (o !== d) o.open = false; }); });
    });
  }


  /* ---------- search inside a collection ---------- */
  function initCollSearch() {
    var box = $('[data-csearch]'); if (!box) return;
    var input = $('[data-csearch-input]', box), clear = $('[data-csearch-clear]', box), status = $('[data-csearch-status]', box);
    var grid = $('[data-csearch-grid]'), empty = $('[data-csearch-empty]'), pager = $('[data-csearch-pager]');
    if (!input || !grid) return;
    var pages = parseInt(box.getAttribute('data-pages'), 10) || 1, loaded = pages <= 1, loading = null;
    var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim(); };
    var groups = [];
    try { groups = JSON.parse($('[data-csearch-aliases]', box).textContent || '[]').map(function (l) { return l.split(',').map(norm).filter(Boolean); }).filter(function (g) { return g.length; }); } catch (e) {}
    function variants(word) {
      var out = [word];
      groups.forEach(function (g) { if (g.some(function (w) { return w === word || (word.length > 3 && w.indexOf(word) === 0); })) out = out.concat(g); });
      if (word.length > 3 && /s$/.test(word)) out.push(word.slice(0, -1));
      return out;
    }
    function cards() { return $$('.card', grid); }
    function textOf(c) {
      if (c._st == null) { var t = c.getAttribute('data-search-text') || ''; var h = c.querySelector('.card__title, h3, h2'); c._st = ' ' + norm(t + ' ' + (h ? h.textContent : '')) + ' '; }
      return c._st;
    }
    function loadAll() {
      if (loaded) return Promise.resolve();
      if (loading) return loading;
      var base = box.getAttribute('data-base'), sid = box.getAttribute('data-section'), jobs = [];
      var cur = parseInt(new URLSearchParams(location.search).get('page'), 10) || 1;
      for (var n = 1; n <= Math.min(pages, 20); n++) {
        if (n === cur) continue;
        (function (n) {
          var u = base + (base.indexOf('?') > -1 ? '&' : '?') + 'page=' + n + '&section_id=' + encodeURIComponent(sid);
          jobs.push(fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
            var tmp = document.createElement('div'); tmp.innerHTML = html;
            var g = tmp.querySelector('[data-csearch-grid]'); if (!g) return;
            $$('.card', g).forEach(function (c) { c.setAttribute('data-csearch-extra', ''); c.classList.add('is-in'); c.hidden = true; grid.appendChild(c); });
          }).catch(function () {}));
        })(n);
      }
      loading = Promise.all(jobs).then(function () { loaded = true; initEmblems && initEmblems(grid); });
      return loading;
    }
    function run() {
      var q = norm(input.value), words = q ? q.split(' ') : [];
      clear.hidden = !input.value;
      if (!words.length) {
        cards().forEach(function (c) { c.hidden = c.hasAttribute('data-csearch-extra'); });
        empty.hidden = true; if (pager) pager.hidden = false; status.textContent = ''; return;
      }
      var finder = words.map(variants), shown = 0;
      cards().forEach(function (c) {
        var t = textOf(c);
        var ok = finder.every(function (vs) { return vs.some(function (v) { return t.indexOf(' ' + v) > -1; }); });
        c.hidden = !ok; if (ok) { shown++; c.classList.add('is-in'); }
      });
      if (pager) pager.hidden = true;
      empty.hidden = shown > 0;
      if (!shown) {
        var term = $('[data-csearch-term]', empty); if (term) term.textContent = input.value.trim();
        var all = $('[data-csearch-all]', empty); if (all) all.href = box.getAttribute('data-all-url') + encodeURIComponent(input.value.trim());
      }
      status.textContent = loaded ? (shown === 1 ? '1 piece found' : shown + ' pieces found') : 'Searching…';
    }
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { run(); if (!loaded && input.value.trim()) loadAll().then(run); }, 120);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } if (e.key === 'Escape') { input.value = ''; run(); } });
    clear.addEventListener('click', function () { input.value = ''; run(); input.focus(); });
    var reset = $('[data-csearch-reset]'); if (reset) reset.addEventListener('click', function () { input.value = ''; run(); input.focus(); });
    var pre = new URLSearchParams(location.search).get('find'); if (pre) { input.value = pre; run(); loadAll().then(run); }
  }

  /* ---------- reveal on scroll ---------- */
  var revealIO = null;
  function initReveal(root) {
    if (!document.body.classList.contains('has-reveal')) return;
    if (!('IntersectionObserver' in window) || reduce) { $$('.reveal', root).forEach(function (r) { r.classList.add('is-in'); }); return; }
    if (!revealIO) revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    $$('.reveal:not(.is-in)', root).forEach(function (r, i) { r.style.transitionDelay = Math.min(i % 4, 3) * 90 + 'ms'; revealIO.observe(r); });
  }

  function boot() {
    if (document.body.getAttribute('data-reveal') !== 'false') document.body.classList.add('has-reveal');
    initReveal(document);
    initEmblems(document);
    initHome();
    initHeader();
    initAnnounce();
    initDrawers();
    initCartDrawer();
    $$('[data-product]').forEach(initProduct);
    initRelated();
    initFilters(); initCollSearch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target); initEmblems(e.target);
    $$('[data-product]', e.target).forEach(initProduct);
    if ($('[data-header]', e.target)) { initHeader(); initHome(); }
    if ($('[data-announce]', e.target)) initAnnounce();
    $$('.reveal', e.target).forEach(function (r) { r.classList.add('is-in'); });
  });
})();

/* ---------- rotating customer testimonials ---------- */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    (root || document).querySelectorAll('[data-tslider]').forEach(function (w) {
      if (w._ts) return; w._ts = true;
      var slides = w.querySelectorAll('[data-slide]'), dots = w.querySelectorAll('[data-dot]');
      if (slides.length < 2) return;
      var i = 0, timer = null, secs = parseInt(w.getAttribute('data-interval'), 10) || 6;
      var auto = w.getAttribute('data-autoplay') === 'true' && !reduce;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }
      function play() { stop(); if (auto) timer = setInterval(function () { go(i + 1); }, secs * 1000); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      var p = w.querySelector('[data-prev]'), nx = w.querySelector('[data-next]');
      if (p) p.addEventListener('click', function () { go(i - 1); play(); });
      if (nx) nx.addEventListener('click', function () { go(i + 1); play(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-dot')); play(); }); });
      w.addEventListener('mouseenter', stop); w.addEventListener('mouseleave', play);
      w.addEventListener('focusin', stop); w.addEventListener('focusout', play);
      var sx = null;
      w.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
      w.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); play(); });
      document.addEventListener('shopify:block:select', function (e) { var k = Array.prototype.indexOf.call(slides, e.target); if (k > -1) { go(k); stop(); } });
      play();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---------- live spot prices (text) ---------- */
(function () {
  function fmt(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function init(root) {
    (root || document).querySelectorAll('[data-spot-live]').forEach(function (box) {
      if (box._live) return; box._live = true;
      var bar = box.closest('.spot-bar');
      var updated = bar && bar.querySelector('[data-updated]');
      var fallback = box.querySelector('[data-fallback]');
      var every = (parseInt(box.getAttribute('data-refresh'), 10) || 60) * 1000;
      var prev = {};
      function load() {
        var chips = box.querySelectorAll('[data-metal]');
        var jobs = Array.prototype.map.call(chips, function (chip) {
          var sym = chip.getAttribute('data-metal');
          return fetch('https://api.gold-api.com/price/' + sym, { cache: 'no-store' })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function (d) {
              var p = d && (d.price != null ? d.price : (d.data && d.data.price));
              if (p == null || isNaN(p)) throw new Error('no price');
              p = Number(p) + (parseFloat(chip.getAttribute('data-add')) || 0);
              var spotEl = chip.querySelector('[data-price]'); if (spotEl) spotEl.textContent = fmt(p);
              var ourEl = chip.querySelector('[data-price-our]');
              if (ourEl) { var mk = parseFloat(chip.getAttribute('data-markup')) || 0; ourEl.textContent = fmt(p * (1 + mk / 100)); }
              var c = chip.querySelector('[data-chg]');
              if (prev[sym] != null && c) {
                var diff = p - prev[sym];
                chip.classList.toggle('is-up', diff > 0); chip.classList.toggle('is-down', diff < 0);
                if (diff !== 0) { chip.classList.remove('is-flash'); void chip.offsetWidth; chip.classList.add('is-flash'); }
                c.textContent = diff > 0 ? '▲' : (diff < 0 ? '▼' : '');
              }
              prev[sym] = p;
              return d.updatedAt || d.updated_at || null;
            });
        });
        Promise.all(jobs).then(function (times) {
          box.classList.add('is-live'); if (fallback) fallback.hidden = true;
          var t = times.filter(Boolean)[0]; var dt = t ? new Date(t) : new Date();
          if (updated) updated.textContent = 'Updated ' + dt.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        }).catch(function () {
          if (box.classList.contains('is-live')) return;
          box.classList.add('is-failed'); if (fallback) fallback.hidden = false;
          if (updated) updated.textContent = '';
        });
      }
      load();
      setInterval(function () { if (!document.hidden) load(); }, every);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---------- header search bar with product suggestions ---------- */
(function () {
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function init() {
    document.querySelectorAll('[data-hsearch]').forEach(function (box) {
      if (box._hs) return; box._hs = true;
      var input = box.querySelector('[data-hsearch-input]'), out = box.querySelector('[data-hsearch-results]');
      var url = box.getAttribute('data-search-url') || '/search';
      var suggest = box.getAttribute('data-suggest') === 'true';
      var t = null, last = '';
      function close() { out.hidden = true; input.setAttribute('aria-expanded', 'false'); }
      function render(q, items) {
        var all = url + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
        var html = items.length ? items.map(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          var price = p.price != null && Number(p.price) > 0 ? p.price_label || ('$' + Number(p.price).toLocaleString('en-US', { minimumFractionDigits: 2 })) : 'Price on request';
          return '<a class="hsearch__item" role="option" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="hsearch__ph"></span>') +
            '<span class="hsearch__t">' + esc(p.title) + '<small>' + esc(price) + '</small></span></a>';
        }).join('') : '<p class="hsearch__none">No pieces match “' + esc(q) + '”. Try another word, or call us.</p>';
        out.innerHTML = html + '<a class="hsearch__all" href="' + all + '">See all results for “' + esc(q) + '” →</a>';
        out.hidden = false; input.setAttribute('aria-expanded', 'true');
      }
      input.addEventListener('input', function () {
        var q = input.value.trim(); clearTimeout(t);
        if (!suggest || q.length < 2) { close(); return; }
        t = setTimeout(function () {
          last = q;
          fetch(url + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
            .then(function (r) { return r.json(); })
            .then(function (d) { if (q !== last) return; render(q, (d && d.resources && d.resources.results && d.resources.results.products) || []); })
            .catch(function () { if (q === last) render(q, []); });
        }, 220);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); input.blur(); }
        if (e.key === 'ArrowDown') { var f = out.querySelector('a'); if (f && !out.hidden) { e.preventDefault(); f.focus(); } }
      });
      out.addEventListener('keydown', function (e) {
        var links = Array.prototype.slice.call(out.querySelectorAll('a')); var i = links.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); (i > 0 ? links[i - 1] : input).focus(); }
        if (e.key === 'Escape') { close(); input.focus(); }
      });
      document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
      input.addEventListener('focus', function () { if (out.innerHTML && input.value.trim().length >= 2) { out.hidden = false; } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ---------- keep phone numbers on one line ---------- */
(function () {
  var re = /(\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}/g;
  function run(root) {
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      if (!n.nodeValue || !/\d{3}[\s.-]\d{4}/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
      var p = n.parentNode; if (!p || /^(SCRIPT|STYLE|TEXTAREA|INPUT|OPTION)$/.test(p.nodeName) || (p.classList && p.classList.contains('nowrap'))) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT; } });
    var list = []; while (w.nextNode()) list.push(w.currentNode);
    list.forEach(function (n) {
      var txt = n.nodeValue, frag = document.createDocumentFragment(), last = 0, m; re.lastIndex = 0;
      while ((m = re.exec(txt))) {
        if (m.index > last) frag.appendChild(document.createTextNode(txt.slice(last, m.index)));
        var sp = document.createElement('span'); sp.className = 'nowrap'; sp.textContent = m[0]; frag.appendChild(sp); last = m.index + m[0].length;
      }
      if (!last) return;
      if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
